(async function () {
    // 1. Check if the elements exist on the page before loading the heavy libraries
    const hasGallery = document.querySelector('.gallery a');
    const heroSliderElements = document.querySelectorAll(".hero-slider");
    const hasBottomSlider = document.querySelector('.bottom-slider');

    // If none of the elements exist, exit early and load nothing
    if (!hasGallery && !heroSliderElements.length && !hasBottomSlider) {
        return;
    }

    // 2. Conditionally load SimpleLightbox if a gallery exists
    if (hasGallery) {
        // Dynamically import the script and CSS simultaneously
        const [SimpleLightboxModule] = await Promise.all([
            import("simplelightbox"),
            import('simplelightbox/dist/simple-lightbox.css')
        ]);

        const SimpleLightbox = SimpleLightboxModule.default;
        new SimpleLightbox('.gallery a', { /* options */ });
    }

    // 3. Conditionally load Swiper if any sliders exist
    if (heroSliderElements.length || hasBottomSlider) {
        // Dynamically import the core, modules, and all required styles in parallel
        const [
            SwiperModule,
            SwiperModules,
            _cssCore,
            _cssNav,
            _cssPag,
            _cssThumbs
        ] = await Promise.all([
            import('swiper'),
            import('swiper/modules'),
            import('swiper/css'),
            import('swiper/css/navigation'),
            import('swiper/css/pagination'),
            import('swiper/css/thumbs')
        ]);

        const Swiper = SwiperModule.default;
        const { Navigation, Pagination, Thumbs, Autoplay, FreeMode } = SwiperModules;

        // Initialize Hero Sliders
        heroSliderElements.forEach(swiperElement => {
            const speed = parseInt(swiperElement.dataset.speed, 10) || 300;
            const delay = (parseInt(swiperElement.dataset.delay, 10) || 3) * 1000;

            new Swiper(swiperElement, {
                // Pass the required modules explicitly to the instance
                modules: [Pagination, Autoplay],
                direction: 'horizontal',
                loop: true,
                speed: speed,
                autoplay: {
                    delay: delay,
                    disableOnInteraction: true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                }
            });
        });

        // Initialize Bottom Slider
        if (hasBottomSlider) {
            new Swiper('.bottom-slider', {
                modules: [Autoplay, FreeMode],
                direction: 'horizontal',
                loop: true,
                slidesPerView: 2,
                spaceBetween: 0,
                freeMode: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true
                },
                speed: 3000,
                breakpoints: {
                    576: { slidesPerView: 3 },
                    992: { slidesPerView: 4 },
                    1200: { slidesPerView: 6, loop: false },
                },
            });
        }
    }
})();
